export default {
  getProgress: (axios, digitalCertificateId) =>
    axios.get(`/api/digitalCertificates/${digitalCertificateId}/progress`),
}
